<template>
    <div class="main-box mh-a">
        <iristar-dividing>{{ $t("HOME_NAV.Join") }}</iristar-dividing>
        <img width="100%" :src="`/static/img/${bannerUrl}`" alt="JoinUs" />
        <!-- 详细信息 -->
        <div class="join-box">
            <!-- 左半部分 -->
            <div class="w200px pc-hidden">
                <button :class="{ 'join-btn-cur': joinIndex === btn.id }" @click="checkNow(btn)"
                    class="iristar-join-btn fs18" v-for="(btn, idx) in joinInfo" :key="`${idx}_btn`">
                    {{ btn.name }}
                </button>
                <div class="p20 lh20">
                    <p>{{ $t("button.contactUs") }}</p>
                    <p>hr@iristar.com.cn</p>
                    <!-- <p>010-82087021</p> -->
                </div>
            </div>
            <ul class="w-total hasUl flex mv20 c-g-d border-gray lh45 text-center">
                <li v-for="(item, index) in joinInfo" :class="{ 'join-btn-cur': joinIndex === item.id }"
                    :key="`${index}_factory`" @click="checkNow(item)">
                    {{ item.name }}
                </li>
            </ul>
            <!-- 右半部分 -->
            <div class="w-total p20 flex1" v-if="joinData">
                <!-- 福利待遇 -->
                <div v-if="joinIndex === 1">
                    <el-row :gutter="20">
                        <el-col :span="6" v-for="(welfare, x) in joinData" :key="`${x}_welfare`"
                            class="text-center mv30 m-icon">
                            <img width="100%" :src="welfare.img" :alt="welfare.name" />
                            <h4 class="fs16 lh40 c-blue">
                                {{ welfare.name }}
                            </h4>
                        </el-col>
                    </el-row>
                </div>
                <!-- 社会招聘校园招聘 -->
                <div class="fs16 c-g-d lh28" v-else-if="joinIndex === 2 || joinIndex === 3">
                    <el-row>
                        <el-col :span="setIndex(tx)" v-for="(title, tx) in joinTitle" :key="`${tx}_title`">{{ title.val
                            }}</el-col>
                        <el-col :span="2"></el-col>
                    </el-row>
                    <div v-for="(row, rx) in joinData" :key="`${rx}_row`">
                        <el-row class="join-list lh40 ph10 c-pointer hover-shadow" @click.native="showText(row)">
                            <el-col :span="8" class="fs14">{{
            row[joinTitle[0].key]
        }}</el-col>
                            <el-col :span="6" class="fs14">{{
            row[joinTitle[1].key]
        }}</el-col>
                            <el-col :span="8" class="fs14">{{
            row[joinTitle[2].key]
        }}</el-col>
                            <el-col :span="2" class="text-right"><i class="el-icon-arrow-down"></i></el-col>
                        </el-row>
                        <transition name="el-zoom-in-top">
                            <div v-if="row.workShow" class="p20 lh30">
                                <ul v-for="(work, workIndex) in row.work" :key="`${workIndex}_work`">
                                    <h3>{{ work.name }}</h3>
                                    <li v-for="(term, tx) in work.data" :key="`${tx}_term`">
                                        {{ term }}
                                    </li>
                                </ul>
                            </div>
                        </transition>
                    </div>
                </div>
                <!-- 办公环境 -->
                <div class="fs16 c-g-d lh28" v-else-if="joinIndex === 4">
                    <swiper ref="mySwiper" class="swiper-b" :options="swiperOptions">
                        <swiper-slide class="text-center" v-for="(item, index) in joinData.tj" :key="`${index}_img`">
                            <img :src="item" class="has-img" />
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IristarDividing from "@/components/IristarDividing";
import JoinUsList from "@/assets/joinUs/joinUsList";
import JoinUsListEn from "@/assets/joinUs/joinUsList-en";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
    name: "IristarJoinUs",
    components: { IristarDividing, Swiper, SwiperSlide },
    data() {
        return {
            joinIndex: 1,
            joinData: null,
            joinTitle: [],
            activeNames: [],
            swiperOptions: {
                // 自动高度
                // autoHeight: true,
                // slidesPerView: 4,
                // 自动播放
                autoplay: true,
                // 环路播放
                loop: true,
                // 分页器
                pagination: {
                    type: "fraction",
                    el: ".swiper-pagination",
                },
                // 前进后退按钮
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
        };
    },
    computed: {
        bannerUrl() {
            return this.$store.state.language === "zh"
                ? "banner.jpg"
                : "banner-en.jpg";
        },
        joinInfo() {
            return this.$store.state.language === "zh"
                ? JoinUsList
                : JoinUsListEn;
        },
    },
    mounted() {
        if (this.$store.state.language === "zh") {
            this.joinData = JoinUsList[0].list;
        } else {
            this.joinData = JoinUsListEn[0].list;
        }
    },
    methods: {
        setIndex(i) {
            console.log(i);
            let x;
            if (i === 0) {
                x = 8;
            } else if (i === 1) {
                x = 6;
            } else if (i === 2) {
                x = 8;
            }
            return x;
        },
        showText(obj) {
            obj.workShow = !obj.workShow;
        },
        checkNow(obj) {
            this.joinIndex = obj.id;
            switch (obj.id) {
                case 1:
                    this.joinData = obj.list;
                    break;
                case 2:
                    this.joinData = obj.job;
                    this.joinTitle = obj.titleList;
                    break;
                case 3:
                    this.joinData = obj.job;
                    this.joinTitle = obj.titleList;
                    break;
                case 4:
                    this.joinData = obj.data;
                    break;
            }
        },
    },
};
</script>

<style lang="less" scoped></style>